import {React,useEffect,useState,useContext} from "react";
import CustomButton from "../CustomButton";
import { updateLesson,getTasks } from "../../api/Api";
import { OrganizationContext } from "../../contexts/OrganizationContextProvider";
import { showToast } from "../../utils/toastUtils";
import { useFormik } from "formik";
import * as Yup from "yup";
import ModalUI from "../ui/ModalUI";
import ShortTextInput from "../Inputs/ShortTextInput";
import CustomSelectBox from './../Inputs/CustomSelectBox';
import CustomTemplateDropdown from "../Inputs/CustomTemplateDropdown";
import AddUpdateLessonTemplateModal from "./AddUpdateLessonTemplateModal";
import SelectLessonTemplateModal from "./SelectLessonTemplateModal";
import RichTextEditor from "../texts/RichTextEditor";
import { HiOutlineDotsHorizontal } from "react-icons/hi";


function UpdateLessonModal({ show, handleClose, lesson, onUpdateLesson, workStreamId }) {
  return (
 <ModalUI show={show} handleClose={handleClose} title="Update Lesson">
      <UpdateLessonForm
        handleClose={handleClose}
        onUpdateLesson={onUpdateLesson}
        lesson={lesson}
        workStreamId={workStreamId} // pass workStream_Id if needed
      />
    </ModalUI>
  );
}



function UpdateLessonForm({ handleClose, lesson, onUpdateLesson, workStreamId }) {
  const [taskList, setTaskList] = useState([]);
  const { data: organization } = useContext(OrganizationContext);
  const [showAddTemplateModal, setShowAddTemplateModal] = useState(false);
  const [showSelectTemplateModal, setShowSelectTemplateModal] = useState(false);
  console.log("workStream_Id", workStreamId);

    // Fetch all tasks of the organization
    useEffect(() => {
      getTasks({ organization_id: organization.current_organization.id, workStream_id: workStreamId })
        .then((response) => {
          if (response.status === 200) {
            const tasks = response.data.map((task) => ({
              ...task,
              id: task.id,
              name: task.title,
            }));
            setTaskList(tasks);
          }
        })
        .catch((error) => {
          showToast("Failed to fetch tasks", "error");
          console.error(error);
        });
    }, [organization.current_organization.id]);
  console.log("lesson", lesson);
  
  // Formik configuration
  const formik = useFormik({
    initialValues: {
      title: lesson?.title || "",
      task_id: lesson?.task?.id ||lesson?.task_id || "", // Use task_id if task is not available
      description: lesson.description || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      task_id: Yup.string().required("Task is required"),
      description: Yup.string()
        .required("Description is required")
        .test('not-empty-html', 'Description cannot be empty', function(value) {
          // Remove HTML tags and check if the remaining content is just whitespace
          const strippedContent = value.replace(/<[^>]*>/g, '').trim();
          return strippedContent.length > 0;
        }),
    }),
    onSubmit: (values, { setSubmitting }) => {
      const lessonPayload = {
        title: values.title,
        task_id: values.task_id,
        description: values.description,
      };

      updateLesson(lesson.id, lessonPayload)
        .then((response) => {
          if (response.status === 200) {
            showToast("Lesson updated successfully", "success");
            if (onUpdateLesson && typeof onUpdateLesson === "function") {
              onUpdateLesson(response.data);
            }
            handleClose(); // Close the modal on success
          }
        })
        .catch((error) => {
          showToast("Failed to update lesson", "error");
          console.error(error);
        })
        .finally(() => setSubmitting(false));
    },
  });

  const dropdownItems = [
    {
      label: 'Use a template',
      onClick: () => setShowSelectTemplateModal(true),
    },
    {
      label: 'Save as template',
      onClick: () => setShowAddTemplateModal(true),
    },
  ];

  return (
    <form onSubmit={formik.handleSubmit}>
      {/* Title Field */}
      <div className="text-start">
        <ShortTextInput
          type="text"
          id="title"
          label="title"
          required
          value={formik.values.title}
          onChange={formik.handleChange}
          placeholder="Enter lesson title"
          className={`form-control ${
            formik.touched.title && formik.errors.title ? "is-invalid" : ""
          }`}
          error={formik.touched.title && formik.errors.title ? formik.errors.title : ""}
        />
      </div>

      {/* Task Field */}
      <div className="mt-3 text-start">
        <CustomSelectBox
          label="Goal"
          required
          value={formik.values.task_id}
          onChange={(e) => formik.setFieldValue("task_id", e.target.value)}
          options={taskList.map((task) => ({
            value: task.id,
            label: task.title,
          }))}
          placeholder="Select Goal"
          error={formik.touched.task_id && formik.errors.task_id ? formik.errors.task_id : ""}
        />
      </div>


      {/* Description Field */}
      <div className="position-relative ">
        <div className="position-absolute end-0 top-0 m-1">
        <CustomTemplateDropdown icon={ HiOutlineDotsHorizontal}  items={dropdownItems}/>
        </div>
        <RichTextEditor
          label="Description"
          id="description"
          placeholder="Enter lesson description..."
          required
          editorValue={formik.values.description}
          setEditorValue={(value) => formik.setFieldValue("description", value)}
          error={formik.touched.description && formik.errors.description ? formik.errors.description : ""}
        />
      </div>

      {showAddTemplateModal && (
        <AddUpdateLessonTemplateModal
          show={showAddTemplateModal}
          handleClose={() => setShowAddTemplateModal(false)}
          refresh={() => {}}
          defaultDescription={formik.values.description}  
        />
      )}

      {showSelectTemplateModal && (
        <SelectLessonTemplateModal
          show={showSelectTemplateModal}
          handleClose={() => setShowSelectTemplateModal(false)}
          title="Use a Template"
          refresh={() => {}}
          handleUse={(template) => {
            formik.setFieldValue("description", template.description);
            setShowSelectTemplateModal(false);
          }}
        />
      )}


      {/* Action Buttons */}
      <div className="text-right d-flex justify-content-center mt-3">
        <CustomButton
          type="submit"
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? "Updating..." : "Update"}
        </CustomButton>
      </div>
    </form>
  );
}

export default UpdateLessonModal;